module.exports = {
  API_ROOT: 'https://hydra-test-dot-td-admin.appspot.com',
  API_SERVER_ROOT: 'https://hydra-test-dot-api-server-dot-td-admin.appspot.com',
  TEACHER_DASHBOARD: 'https://app-test.hapara.com',
  PUGS_BASE: 'https://pugs-test.teacherdashboard.com',
}
